module.exports = __webpack_public_path__ + "static/media/delete-black.582e4807.svg";